import React from 'react';

export const ImpersonationContext = React.createContext({});
